/**
 * @license lucide v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const ArrowBigUpDash = [
  "svg",
  defaultAttributes,
  [
    ["path", { d: "M9 19h6" }],
    ["path", { d: "M9 15v-3H5l7-7 7 7h-4v3H9z" }]
  ]
];

export { ArrowBigUpDash as default };
//# sourceMappingURL=arrow-big-up-dash.js.map
